import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

interface TrackMapTypeChanged {
  map_type: 'roadmap' | 'satellite' | 'street_view';
}

export const trackMapTypeChanged = ({ map_type }: TrackMapTypeChanged): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_map_type_changed/jsonschema/1-0-0',
    data: {
      event_name: 'pca_map_type_changed',
      map_type,
    },
  });
  trackEvent(event);
};
